import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <h4>Fasting Carnivore</h4>
            <p>
              Transformation through ancestral eating and strategic fasting.
              Join thousands who have discovered that decline is not inevitable.
            </p>
          </div>
          <div>
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/stories">Stories</Link></li>
              <li><Link to="/science">Science</Link></li>
              <li><Link to="/programs">Programs</Link></li>
              <li><Link to="/join">Join</Link></li>
            </ul>
          </div>
          <div>
            <h4>Resources</h4>
            <ul>
              <li><Link to="/quick-start">Quick Start Guide</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>
          </div>
          <div>
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy</Link></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/disclaimer">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Fasting Carnivore. All rights reserved.
            This site is for informational purposes only. Consult healthcare professionals
            before making dietary changes.
          </p>
          <p style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: '#999' }}>
            Results vary. No specific outcomes are guaranteed.
          </p>
        </div>
      </div>
    </footer>
  );
}
